/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_LayoutInputs */

const cs_filter_layout = /** @type {(inputs: Filter_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispozice`)
};

const en_filter_layout = /** @type {(inputs: Filter_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layout`)
};

/**
* | output |
* | --- |
* | "Layout" |
*
* @param {Filter_LayoutInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const filter_layout = /** @type {((inputs?: Filter_LayoutInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_LayoutInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filter_layout(inputs)
	return cs_filter_layout(inputs)
});